// The Babylon.js modules the game uses, imported from deep paths so the bundle
// only contains these (importing the '@babylonjs/core' root pulls in everything).

export { Engine } from '@babylonjs/core/Engines/engine';
export { Scene } from '@babylonjs/core/scene';
export { FreeCamera } from '@babylonjs/core/Cameras/freeCamera';
export { HemisphericLight } from '@babylonjs/core/Lights/hemisphericLight';
export { DirectionalLight } from '@babylonjs/core/Lights/directionalLight';
export { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
export { ImageProcessingConfiguration } from '@babylonjs/core/Materials/imageProcessingConfiguration';
export { Color3, Color4 } from '@babylonjs/core/Maths/math.color';
export { Vector3 } from '@babylonjs/core/Maths/math.vector';
export { Mesh } from '@babylonjs/core/Meshes/mesh';
export { VertexData } from '@babylonjs/core/Meshes/mesh.vertexData';
export { TransformNode } from '@babylonjs/core/Meshes/transformNode';
export { DynamicTexture } from '@babylonjs/core/Materials/Textures/dynamicTexture';

import { CreateBox } from '@babylonjs/core/Meshes/Builders/boxBuilder';
import { CreateGround } from '@babylonjs/core/Meshes/Builders/groundBuilder';
import { CreateRibbon } from '@babylonjs/core/Meshes/Builders/ribbonBuilder';
import { CreateTorus } from '@babylonjs/core/Meshes/Builders/torusBuilder';
import { CreateCylinder } from '@babylonjs/core/Meshes/Builders/cylinderBuilder';
import { CreatePlane } from '@babylonjs/core/Meshes/Builders/planeBuilder';
import { CreateSphere } from '@babylonjs/core/Meshes/Builders/sphereBuilder';
// Side effect: enables mesh.thinInstanceAdd etc. (used for trees).
import '@babylonjs/core/Meshes/thinInstanceMesh';

/** Subset of Babylon's MeshBuilder with only the shapes we use. */
export const MeshBuilder = { CreateBox, CreateGround, CreateRibbon, CreateTorus, CreateCylinder, CreatePlane, CreateSphere };

// Weather (src/render/weather.ts): custom shaders for rain streaks and spray, fresnel sheen on wet track.
export { ShaderMaterial } from '@babylonjs/core/Materials/shaderMaterial';
export { ShaderStore } from '@babylonjs/core/Engines/shaderStore';
export { FresnelParameters } from '@babylonjs/core/Materials/fresnelParameters';
